/* eslint-disable prettier/prettier */

import { makeStyles } from '@material-ui/core/styles'


export default makeStyles(theme => ({
  callContainer: {
    height: '80vh',
    position: 'relative',
    backgroundColor: theme.palette.background.default
  },
  roomContainer: {
    position: 'relative',
    height: 'calc(80vh - 90px)'
  },
  errorContainer: {
    color: 'white',
    position: 'absolute',
    top: '50%',
    left: '50%'
  },
  sideMenuContainer: {
    width: '300px', // Largura fixa para o menu lateral
    backgroundColor: '#ffffff', // Cor de fundo do menu lateral
    borderLeft: '1px solid #ddd', // Linha separadora
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' // Sombra para destacar o menu
  },
  toolbarContainer: {
    backgroundColor: 'black',
    display: 'flex',
    justifyContent: 'center',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0
  },
  screenSharingContainer: {
    position: 'absolute',
    top: 10,
    left: 10,
    zIndex: 9
  },
  screenSharingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.4)',
    zIndex: 9,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '22px',
    color: '#fff'
  },
  transcriptContainer: {
    position: 'fixed',
    bottom: '80px',
    right: '20px',
    width: '300px',
    maxHeight: '300px',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    color: 'white',
    borderRadius: '8px',
    padding: '10px',
    overflowY: 'auto',
    zIndex: 1000
  },
  transcriptHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '10px',
    borderBottom: '1px solid #444',
    paddingBottom: '5px'
  },
  closeTranscriptButton: {
    background: 'none',
    border: 'none',
    color: 'white',
    fontSize: '20px',
    cursor: 'pointer',
    '&:hover': {
      color: '#ccc'
    }
  },
  transcriptContent: {
    fontSize: '14px'
  },
  transcriptLine: {
    margin: '5px 0',
    padding: '5px',
    borderRadius: '4px'
  },
  finalTranscript: {
    backgroundColor: 'rgba(255, 255, 255, 0.1)'
  },
  interimTranscript: {
    fontStyle: 'italic',
    opacity: 0.7
  },
  speakerName: {
    fontWeight: 'bold',
    color: '#4CAF50'
  },
  noTranscript: {
    color: '#aaa',
    textAlign: 'center',
    padding: '20px'
  },
  miniPlayer: {
    position: 'fixed',
    bottom:70,
    right: 20,
    width: 340,
    height: 200,
    zIndex: 9999,
    boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
    background: '#fff',
    borderRadius: 12,
    transition: 'all 0.3s',
    overflow: 'hidden'
  },
  miniPlayerVideo: {
  width: '100%',
  height: '100%',
  objectFit: 'cover'
}
}))